import React, { useState, useEffect } from 'react';
import { Card, Button, Typography, Input } from 'antd';
import { ArrowLeftOutlined, ScanOutlined, ClearOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const ScanVerify = () => {
  const navigate = useNavigate();
  const [scanCode, setScanCode] = useState('');
  const inputRef = React.useRef(null);

  // 页面加载后自动聚焦输入框
  useEffect(() => {
    const timer = setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  const handleBack = () => {
    navigate('/dashboard');
  };

  const handleInputChange = (e) => {
    setScanCode(e.target.value);
  };

  const handleClear = () => {
    setScanCode('');
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 100);
  };

  return (
    <div>
      {/* 页面头部 */}
      <div className="page-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Button 
            icon={<ArrowLeftOutlined />} 
            onClick={handleBack}
            type="text"
            size="large"
          />
          <Title level={3} style={{ margin: 0 }}>
            扫码验证
          </Title>
        </div>
      </div>

      {/* 页面内容 */}
      <div className="page-content" style={{ padding: '40px 20px' }}>
        <div style={{ maxWidth: 600, margin: '0 auto' }}>
          <Card
            style={{ 
              borderRadius: 16,
              boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
              textAlign: 'center'
            }}
            bodyStyle={{ padding: '60px 40px' }}
          >
            <ScanOutlined 
              style={{ 
                fontSize: 80, 
                color: '#52c41a', 
                marginBottom: 32 
              }} 
            />
            
            <Title level={2} style={{ marginBottom: 16, color: '#262626' }}>
              扫码验证
            </Title>
            
            <Text type="secondary" style={{ fontSize: 16, marginBottom: 40, display: 'block' }}>
              请扫描或输入二维码进行验证
            </Text>

            <div style={{ marginBottom: 32 }}>
              <Input
                ref={inputRef}
                placeholder="请扫描或输入二维码"
                value={scanCode}
                onChange={handleInputChange}
                prefix={<ScanOutlined />}
                size="large"
                style={{ 
                  height: '56px',
                  fontSize: '16px',
                  borderRadius: '8px'
                }}
                autoComplete="off"
              />
            </div>

            <Button 
              type="default" 
              size="large" 
              onClick={handleClear}
              icon={<ClearOutlined />}
              style={{ 
                width: '200px', 
                height: '48px', 
                fontSize: '16px',
                borderRadius: '8px'
              }}
            >
              清除
            </Button>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ScanVerify;